import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfMake.vfs;

export function exportTsdTablesToPdf(sheetsData) {
  const content = [];

  function sanitizeRow(row, length) {
    return Array.from({ length }, (_, i) => {
      const cell = row?.[i];
      return typeof cell !== 'undefined' && cell !== null ? cell : '';
    });
  }

  function chunkArray(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }

  sheetsData.forEach(({ sheetName, headers, subHeaders, rows, weeklyTotalRow, monthlyTotalRow }, index) => {
    const monthChunks = chunkArray(subHeaders, 3); // 3 months per chunk

    monthChunks.forEach((monthGroup, groupIndex) => {
      const reportSpan = monthGroup.reduce((total, m) => total + m.ranges.length + 1, 0);

      if (groupIndex === 0) {
		  content.push({
		    text: `LINE ${sheetName} - ${headers.lineLeader || 'N/A'} (LINE LEADER)`,
		    style: 'sectionHeader',
		    margin: [0, index > 0 ? 20 : 0, 0, 8]
		  });
		}


      // Header rows
      const firstHeader = ["NAME", "JOB POSITION"];
		firstHeader.push(
		  { text: "MONTHLY PRODUCTIVITY REPORT", colSpan: reportSpan, alignment: 'center', bold: true },
		  ...Array(reportSpan - 1).fill("")
		);


      const monthRow = ["", ""];
      monthGroup.forEach(month => {
        monthRow.push(month.name, ...Array(month.ranges.length).fill(""));
      });

      const rangeRow = ["", ""];
      monthGroup.forEach(month => {
        month.ranges.forEach(range => rangeRow.push(range));
        rangeRow.push("TOTAL");
      });

      const expectedLength = firstHeader.length;

      const adjustedRows = [
        sanitizeRow(
		  firstHeader.map(cell =>
		    typeof cell === 'object'
		      ? { ...cell, fillColor: '#d9e1f2' } // light gray
		      : { text: cell, fillColor: '#d9e1f2' }
		  ),
		  expectedLength
		),

        sanitizeRow(
		  monthRow.map(cell =>
		    typeof cell === 'object'
		      ? { ...cell, fillColor: '#d9e1f2' } // light blue
		      : { text: cell, fillColor: '#d9e1f2' }
		  ),
		  expectedLength
		),

        sanitizeRow(
		  rangeRow.map(cell =>
		    typeof cell === 'object'
		      ? { ...cell, fillColor: '#d9e1f2' }
		      : { text: cell, fillColor: '#d9e1f2' }
		  ),
		  expectedLength
		),

        sanitizeRow(
          [
            { text: `LINE ${sheetName} - ${headers.lineLeader || 'N/A'} (LINE LEADER)`, colSpan: 2, bold: true },
            {},
            ...Array(reportSpan).fill("")
          ],
          expectedLength
        ),
        ...rows.map(originalRow => {
          const base = originalRow.slice(0, 2);
          let offset = 2;
          monthChunks.slice(0, groupIndex).forEach(prevGroup => {
            offset += prevGroup.reduce((acc, m) => acc + m.ranges.length + 1, 0);
          });
          const slice = originalRow.slice(offset, offset + reportSpan);
          return sanitizeRow([...base, ...slice], expectedLength);
        }),

        // WEEKLY TOTAL ROW
		(() => {
		  const base = weeklyTotalRow.slice(0, 2).map(text => ({
		    text,
		    fillColor: '#DAF6F1', // light green
		    bold: true
		  }));

		  let offset = 2;
		  monthChunks.slice(0, groupIndex).forEach(prevGroup => {
		    offset += prevGroup.reduce((acc, m) => acc + m.ranges.length + 1, 0);
		  });

		  const slice = weeklyTotalRow.slice(offset, offset + reportSpan).map(text => ({
		    text,
		    fillColor: '#DAF6F1',
		    bold: true
		  }));

		  return sanitizeRow([...base, ...slice], expectedLength);
		})(),


        // MONTHLY TOTAL ROW
		(() => {
		  const base = monthlyTotalRow.slice(0, 2).map(text => ({
		    text,
		    fillColor: '#F6DADF', // light pink/red
		    bold: true
		  }));

		  let offset = 2;
		  monthChunks.slice(0, groupIndex).forEach(prevGroup => {
		    offset += prevGroup.reduce((acc, m) => acc + m.ranges.length + 1, 0);
		  });

		  const slice = monthlyTotalRow.slice(offset, offset + reportSpan).map(text => ({
		    text,
		    fillColor: '#F6DADF',
		    bold: true
		  }));

		  return sanitizeRow([...base, ...slice], expectedLength);
		})(),

      ];

      content.push({
        table: {
          headerRows: 3,
          widths: Array(expectedLength).fill("*"),
          body: adjustedRows
        },
        layout: 'grid',
        dontBreakRows: false
      });
    });
  });

  const docDefinition = {
  content,
  pageSize: 'A3',
  pageOrientation: 'landscape',
  pageMargins: [20, 20, 20, 20],
  defaultStyle: {
    fontSize: 8
  },
  styles: {
    sectionHeader: {
      bold: true,
      fontSize: 9,
      margin: [0, 10, 0, 5]
    }
  }
  };

  const now = new Date();
  const timestamp = `${now.getMonth() + 1}_${now.getDate()}_${now.getFullYear()}-${now.getHours()}_${now.getMinutes()}`;
  pdfMake.createPdf(docDefinition).download(`TSD_Report_All_Lines_${timestamp}.pdf`);
}
